<template>
  <b-container>
    <card>
      <h4 slot="header" class="card-title">{{ $t("message.editEmployee") }}</h4>
      <div v-if="loading" class="text-center text-primary my-2">
        <b-spinner class="align-middle"></b-spinner>
      </div>
      <b-alert v-else-if="error" class="text-center" variant="danger" show>
        <p>{{ $t("message.somethingWentWrong") }}</p>
        <strong>error</strong>
        <router-link class="btn btn-primary" :to="{ name: 'employees' }">
          {{ $t("message.goBack") }}
        </router-link>
      </b-alert>
      <employee-form
        v-else
        :employee="employee"
        :saving="saving"
        @submit="submit"
      ></employee-form>
    </card>
  </b-container>
</template>

<script>
import { mapActions } from "vuex";
import { errorMessage } from "@/helpers/bookingSearch";
import EmployeeForm from "./EmployeeForm";

export default {
  components: {
    EmployeeForm
  },
  methods: {
    ...mapActions({
      fetchEmployee: "employees/fetchEmployee",
      updateEmployee: "employees/updateEmployee"
    }),
    async submit(employee) {
      try {
        this.saving = true;
        await this.updateEmployee(employee);
        this.$notify({
          type: "success",
          title: "Success",
          text: this.$t("message.employeeSaved")
        });
        this.$router.push("/management/employees");
      } catch (e) {
        this.$notify({
          type: "danger",
          title: this.$t("message.error"),
          text: errorMessage(e, "Could not save employee.")
        });
      } finally {
        this.saving = false;
      }
    }
  },
  computed: {
    employee() {
      return this.$store.getters["employees/employeeById"](
        this.$route.params.id
      );
    }
  },
  data() {
    return {
      loading: true,
      saving: false,
      error: null
    };
  },
  async created() {
    const { id } = this.$route.params;

    if (!id) {
      this.$router.push("/management/employees");
    }

    try {
      if (!this.employee) {
        await this.fetchEmployee(id);
      }
    } catch (e) {
      this.error = e.message;
    } finally {
      this.loading = false;
    }
  }
};
</script>
